import { PUBLIC_SITE } from 'src/interviews/requests/settings';
export async function createPaymentIntent({
  productId,
  productDescription,
  amount,
}: {
  productId?: string;
  productDescription?: string;
  /** Amount in USD */
  amount?: number;
}): Promise<{ clientSecret: string; customerId: string } | undefined> {
  const url = `${PUBLIC_SITE}/stripe/create_payment_intent`;

  const res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      product_id: productId,
      product_description: productDescription,
      amount,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok) {
    const responseBody = await res.json();

    const error = {
      data: {
        status: res.status,
        body: responseBody,
      },
    };

    throw error;
  }

  return await res.json();
}

export async function updateCustomer({
  customerId,
  email,
  name,
  phone,
}: {
  customerId: string;
  email?: string;
  name: string;
  phone?: string;
}): Promise<void> {
  const url = `${PUBLIC_SITE}/stripe/update_customer`;

  const res = await fetch(url, {
    method: 'PATCH',
    body: JSON.stringify({
      customerId,
      email,
      name,
      phone,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok) {
    const responseBody = await res.json();

    const error = {
      data: {
        status: res.status,
        body: responseBody,
      },
    };

    throw error;
  }

  return await res.json();
}
